export default "__VITE_ASSET__13375fca__"